import React from "react";
import vt_b_hov from "../../images/vehicle-types/hover/vt_b_hov.svg";
import vt_b5_hov from "../../images/vehicle-types/hover/vt_b5_hov.svg"
import vt_c_hov from "../../images/vehicle-types/hover/vt_c_hov.svg";
import vt_d_hov from "../../images/vehicle-types/hover/vt_d_hov.svg";
import vt_a_hov from "../../images/vehicle-types/hover/vt_a_hov.svg";
import vt_e_hov from "../../images/vehicle-types/hover/vt_e_hov.svg";
import {ReactSVG} from "react-svg";
import {VehicleGroup} from "../../model/vehicle";

interface VehicleGroupSVG {
    vehicleGroup: VehicleGroup;
}

export const VehicleGroupSVG = ({vehicleGroup}: VehicleGroupSVG) => {
    return (
        <div className={"vehicle-group-svg"}>
            {vehicleGroup === VehicleGroup.B && (<ReactSVG src={vt_b_hov}/>)}
            {vehicleGroup === VehicleGroup.B5 && (<ReactSVG src={vt_b5_hov}/>)}
            {vehicleGroup === VehicleGroup.C && (<ReactSVG src={vt_c_hov}/>)}
            {vehicleGroup === VehicleGroup.D && (<ReactSVG src={vt_d_hov}/>)}
            {vehicleGroup === VehicleGroup.A && (<ReactSVG src={vt_a_hov}/>)}
            {vehicleGroup === VehicleGroup.E && (<ReactSVG src={vt_e_hov}/>)}
        </div>
    );
};